// Clerk managed-auth feature flag — mirrors the backend CLERK_ISSUER switch.
// Unset key -> legacy email/password auth, Clerk code paths stay dormant.
export const CLERK_PUBLISHABLE_KEY =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || "";
export const clerkEnabled = Boolean(CLERK_PUBLISHABLE_KEY);
